import ForgotPasswordPage from "../../components/PublicLayout/ForgotPasswordPage/ForgotPasswordPage";
import LoginPage from "../../components/PublicLayout/LoginPage/LoginPage";
import RegistrationPage from "../../components/PublicLayout/RegistrationPage/RegistrationPage";
import PrivacyPolicy from "../../features/common/TerminiCondizioniPage/PrivacyPolicy";
import TerminiCondizioniPage from "../../features/common/TerminiCondizioniPage/TerminiCondizioniPage";

const publicRoutes = [
  {
    path: "/login",
    element: <LoginPage />,
  },
  {
    path: "/registration",
    element: <RegistrationPage />,
  },
  {
    path: "/forgot-password",
    element: <ForgotPasswordPage />,
  },
  {
    path: "/",
    element: <LoginPage />,
  },
  {
    path: "/termini-e-condizioni",
    element: <TerminiCondizioniPage />,
  },
  {
    path: "/privacy-policy",
    element: <PrivacyPolicy />,
  },
];

export default publicRoutes;
